import * as z from "zod/v4";

const abTest = z.object({
  id: z.string(),
  type: z.enum(["imessage_channel"]),
  status: z.enum(["active", "ended"]),
  name: z.string(),
  startedAt: z.date(),
  endedAt: z.date().nullable(),
});

export const listAbTests = {
  name: "listAbTests" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ active: z.array(abTest), ended: z.array(abTest) }),
};
